export default "__VITE_ASSET__Cy9Nxva3__"